import axios from 'axios';
import accessTokenRequest from '@/utils/custom-axios';

export const baseApiUrl = `${process.env.VUE_APP_API}`;
export const FILES_FETCH_RECORDS_URL = `${baseApiUrl}/messages/session/files`;
export const FILES_FETCH_FILE_URL = `${baseApiUrl}/messages/files`
export const FilesService = {
  generatePatientHeaders(patientToken) {
    return {
      Authorization: `Token ${patientToken}`,
    };
  },

  getFiles(token) {
    return axios.get(
      FILES_FETCH_RECORDS_URL,
      {
        headers: this.generatePatientHeaders(token),
      }
    );
  },
  getLabResults(params = {}) {
    return accessTokenRequest.get(
      `${baseApiUrl}/messages/labresults`,
      {
        params,
      },
    );
  },
  getLabResultFileURL(uploadid){
    return accessTokenRequest.get(
      `${baseApiUrl}/messages/labresults/${uploadid}`,
    );
  },
  //use uploadid
  getFileURL(token, uploadid){
    return axios.get(
      `${FILES_FETCH_FILE_URL}/${uploadid}`,
      {
        headers: this.generatePatientHeaders(token),
      }
    )
  },
  uploadPrescription(formData) {
    return accessTokenRequest.post(
      `${baseApiUrl}/prescriptions`,
      formData,
    );
  },
  uploadId(formData) {
    return accessTokenRequest.post(
      `${baseApiUrl}/ids`,
      formData,
    );
  },
}